import {defaultAxios, IParams} from "../base";

interface IFetchSelectApartmentList extends IParams{
    // ldongCode: string; // 법정동 코드
    // apartmentName: string; // 물건
    // buildingType: string; // "10": 아파트, "20": 오피스텔, "": 전체
    // searchText: string; // 주소 + 물건명 복합 검색
}

export const fetchSelectApartmentList = async (params:IFetchSelectApartmentList) => {
    return await defaultAxios().post('/base/selectApartmentList', params)
}